module.exports = __webpack_public_path__ + "static/NotoSans-BoldItalic-a1375023bb3f9d55dfc6d58685cd6e69.ttf";